import { createTheme } from "@mui/material/styles";
import { styled, alpha } from "@mui/material/styles";
export const dark_theme = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 900,
      lg: 1200,
      xl: 1536,
    },
  },
  shape: {
    borderRadius: 8, // Увеличиваем скругление
  },
  palette: {
    mode: "dark",
    common: {
      black: "#000",
      white: "#fff",
    },

    primary: {
      main: "#000",
      light: "#fff",
      dark: "#000",
    },

    secondary: {
      main: "#212121",
      light: "#42a5f5",
      dark: "#1565c0",
    },

    text: {
      primary: "#fff", // Тёмно-серый (заменяет значение по умолчанию near-black)
      secondary: "#fff", // Средний серый
      disabled: "#A0AEC0", // Светло-серый
      hint: "#A0AEC0", // Совпадает с disabled для консистентности
      banner: "#fff",
      dark: "#000",
    },
  },

  color: {
    main: "#2B2B2B",
    secondary: "#fff",
    third: "#D7D7D7",
    body: "#424242",
    banner: "#3B3B3B",
    card: "#2B2B2B",
    hint: "#A0AEC0", // Совпадает с disabled для консистентности
    input: "#F5F5F5", // Светло-серый
    input_hover: "#F5F5F5", // Светло-серый
    button: "#C8C5C5",
    gradient1: "#fff",
    gradient2: alpha("#2912f0", 0.3),
    gradient3: alpha("#f30a0a", 0.3),
  },
});

export default dark_theme;
